import * as React from "react";
import { Dialog, Button } from "@blueprintjs/core";
import { css } from "@emotion/core";

interface ConfirmationDialogProps {
  entityName: string;
  entityType: string;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  actionText?: string;
  actioningText?: string;
  titleAction?: string;
  icon?: string;
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const {
    entityName,
    entityType,
    message,
    isOpen,
    onClose,
    onConfirm,
    isPending,
    actionText = "Delete",
    actioningText = "Deleting...",
    titleAction = "Delete",
    icon = "trash",
  } = props;

  return (
    <Dialog
      className="bp6-dark"
      css={css`
        width: 480px;
      `}
      icon={icon}
      title={`${titleAction} ${entityType}`}
      isOpen={isOpen}
      onClose={() => {
        if (!isPending) {
          onClose();
        }
      }}
    >
      <div
        css={css`
          padding: 1rem;
        `}
      >
        <p>
          Are you sure you want to {titleAction.toLowerCase()}{" "}
          {entityType.toLowerCase()} <strong>{entityName}</strong>?
        </p>
        <p
          css={css`
            color: var(--neutral-3);
            margin-top: 0.5rem;
          `}
        >
          {message}
        </p>
      </div>
      <div
        css={css`
          display: flex;
          justify-content: flex-end;
          gap: 1rem;
          padding: 1rem;
          border-top: 1px solid var(--neutral-4);
        `}
      >
        <Button
          text="Cancel"
          disabled={isPending}
          onClick={() => {
            if (!isPending) {
              onClose();
            }
          }}
        />
        <Button
          text={isPending ? actioningText : actionText}
          disabled={isPending}
          intent="danger"
          onClick={onConfirm}
        />
      </div>
    </Dialog>
  );
}

